import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'reset', 'acciones', 'ver', 'maximizarFiltros', 'maximizarOrdenacion', 'dropdownOrdenacion']

  initialize () {
    this.resetTarget.style.display = 'none'
    this.verTarget.style.display = 'none'
    this.accionesTarget.style.display = 'none'
  }

  connect () {
    this.formTarget.setAttribute('data-turbo', 'true')
    this.formTarget.setAttribute('data-turbo-frame', 'product-comparer')

    this.boundOnFrameLoad = this.onFrameLoad.bind(this)
    document.getElementById('product-comparer')?.addEventListener('turbo:frame-load', this.boundOnFrameLoad)
  }

  disconnect () {
    document.getElementById('product-comparer')?.removeEventListener('turbo:frame-load', this.boundOnFrameLoad)
  }

  onFrameLoad () {
    const comparer = document.querySelector('.rnk-ProductComparer')
    if (!comparer) return

    document.querySelectorAll('.rnk-ProductCompareAndSort_Label').forEach(function (e) {
      e.innerHTML = comparer.dataset.dropdownLabel
    })

    const countEl = document.querySelector('#comparer-page-count')
    const totalEl = document.querySelector('#comparer-page-total')
    if (countEl && comparer.dataset.count) countEl.textContent = comparer.dataset.count
    if (totalEl && comparer.dataset.total) totalEl.textContent = comparer.dataset.total

    window.history.replaceState({}, '', '?' + comparer.dataset.params)

    delete document.querySelector('.mobile-body, .rnk-ProductComparer')?.dataset.loading
    comparer.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  ver () {
    this.maximizarFiltrosTarget.checked = false
    this.verTarget.style.display = 'none'
  }

  reset () {
    this.formTarget.reset()
    this.informarEspera('Quitando filtros')
    this.enviarForm()
    this.resetTarget.style.display = 'none'
    this.accionesTarget.style.display = 'none'
  }

  avisarBuscando () {
    this.informarEspera('Buscando')
  }

  filtrar () {
    this.informarEspera('Filtrando lista')
    this.enviarForm()
  }

  filtrarConEspera () {
    this.informarEspera('Filtrando lista')
    clearTimeout(this.esperaTimeout)

      this.esperaTimeout = setTimeout(() => {
        this.enviarForm()
      }, 1000)
  }

  ordenar () {
    this.informarEspera('Ordenando lista')
    this.enviarForm()
    this.dropdownOrdenacionTarget.classList.remove('open')
  }

  informarEspera (texto) {
    document.querySelector('.mobile-body, .rnk-ProductComparer').dataset.loading = texto
  }

  enviarForm () {
    this.formTarget.requestSubmit()
    this.resetTarget.style.display = ''
    this.verTarget.style.display = ''
    this.accionesTarget.style.display = ''
    this.maximizarOrdenacionTarget.checked = false
  }
}
